// extracted by mini-css-extract-plugin
export default {"homeclients":"HomeClients_homeclients__FdnsP"};